import{decomposeColor as r}from"@material-ui/core/styles/colorManipulator";var o=function(o,a){var t=r(o).values;return"rgba(".concat(t.slice(0,3).join(","),", ").concat(a,")")};export{o as rgba};
